import { Helmet } from "react-helmet-async";

const SITE = "Speed Détresse";
const DEFAULT_DESC =
  "Speed Détresse protège, entretient et suit vos logements dans la durée : Carnet de Santé du Logement, états des lieux intelligents et application dédiée.";

export default function Seo({ title, description, path }) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Protéger, entretenir et suivre vos logements`;
  const desc = description || DEFAULT_DESC;
  const url = path ? `https://speeddetresse.fr${path}` : undefined;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      {url && <meta property="og:url" content={url} />}
      {url && <link rel="canonical" href={url} />}
      <html lang="fr" />
    </Helmet>
  );
}
